import React from 'react';

import PropTypes from 'prop-types';

const BullSeparator = ({ className, ...others }) => (
  // eslint-disable-next-line react/jsx-no-literals
  <span className={className} {...others}>
    &bull;
  </span>
);

BullSeparator.propTypes = {
  className: PropTypes.string
};

export default BullSeparator;
